import { Link, NavLink } from 'react-router-dom';
import styles from '../../css/rulesAndPolicy.module.css'
import Bars from '../Bars';
import { FiArrowLeft } from 'react-icons/fi';

function Rules( ) {

  return (

    <>

      <NavLink to="/info" className="backLink userSelectNone">
        <FiArrowLeft className="backIcon" />
        <span>Powrót</span>
      </NavLink>

      <div className={`${styles.rulesAndPolicyConteiner} userSelectNone`} >

        <h3>Regulamin</h3>

        <p><strong>1.</strong> Serwis GórskaPodwózka jest platformą ogłoszeniową służącą do dodawania oraz wyszukiwania przejazdów i wypraw w góry.</p>

        <p><strong>2.</strong> Użytkownicy korzystają z serwisu na własną odpowiedzialność. Twórca serwisu nie ponosi odpowiedzialności za jakość, bezpieczeństwo ani realizację przejazdów i wypraw górskich.</p>

        <p><strong>3.</strong> Dodając ogłoszenie, użytkownik oświadcza, że podane dane są zgodne z prawdą, nie naruszają prawa ani dóbr innych osób, a w przypadku przejazdu – że posiada odpowiednie uprawnienia do prowadzenia pojazdu.</p>

        <p><strong>4.</strong> Użytkownik odpowiada za stan techniczny pojazdu oferowanego w ogłoszeniu oraz za przestrzeganie przepisów ruchu drogowego podczas realizacji przejazdu.</p>

        <p><strong>5.</strong> Każdy uczestnik wyprawy odpowiada za swoje bezpieczeństwo podczas wędrówki oraz powinien przestrzegać zasad panujących na szlakach górskich.</p>

        <p><strong>6.</strong> Serwis nie odpowiada za przebieg wypraw, warunki atmosferyczne ani bezpieczeństwo czy zdrowie uczestników na trasie (zarówno drogowej, jak i górskiej).</p>

        <p><strong>7.</strong> Serwis przetwarza wyłącznie dane dobrowolnie opublikowane przez użytkownika w ogłoszeniu, zgodnie z Polityką Prywatności.</p>

        <p><strong>8.</strong> Serwis zastrzega sobie prawo do usunięcia ogłoszeń niezgodnych z regulaminem lub naruszających dobre obyczaje.</p>

        <p><strong>9.</strong> Serwis korzysta z zewnętrznych źródeł danych pogodowych. Prezentowane informacje mają charakter poglądowy i nie stanowią gwarancji rzeczywistych warunków atmosferycznych.</p>

        <p><strong>10.</strong> Serwis nie ponosi odpowiedzialności za decyzje użytkowników podejmowane na podstawie prognoz pogody ani za ewentualne skutki błędnych danych meteorologicznych.</p>

        <p><strong>11.</strong> Korzystając z serwisu, użytkownik zobowiązuje się do przestrzegania wszystkich powyższych zasad.</p>

      </div>

      <p className='mycopyright userSelectNone' >
        © 2025 GórskaPodwózka — wszystkie prawa zastrzeżone. Autor: Mateusz
      </p>

      <Bars />

    </>
    
  );
}

export default Rules;